'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var formatTen = function formatTen(area, first, last) {
    if (last) {
        return '(' + area + ') ' + first + ' - ' + last;
    } else if (first) {
        return '(' + area + ') ' + first;
    }
    return area;
};

var divide = function divide(tele) {
    return {
        area: tele.substring(0, 3),
        first: tele.substring(3, 6),
        last: tele.substring(6)
    };
};

var format = function format(input) {
    if (typeof input !== 'undefined') {
        var tele = unformat(input);
        if (tele.length > 10) {
            var country = tele.substring(0, tele.length - 10);
            tele = tele.substring(country.length);

            var _divide = divide(tele),
                _area = _divide.area,
                _first = _divide.first,
                _last = _divide.last;

            return country + ' ' + formatTen(_area, _first, _last);
        }

        var _divide2 = divide(tele),
            area = _divide2.area,
            first = _divide2.first,
            last = _divide2.last;

        return formatTen(area, first, last);
    }
    return '';
};

var unformat = function unformat(input) {
    return input && input.replace(/[^0-9]/g, '');
};

exports.default = {
    format: format,
    unformat: unformat
};
//# sourceMappingURL=index.js.map